import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
// import makeAnimated from "react-select/animated";
import axios from "axios";
import { HOST_URL } from "../../api/Api";
import Axios from "../../../../axios/Axios";

function CarouselButton(props) {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;
  let paramid = props.paramid;
  const finalRetrieveData = props.previewData.ReceiveFinalData
  // const animatedComponents = makeAnimated();
  const [defaultButtnData, setdefaultButtnData] = useState();
  const [callToAction, setCallToAction] = useState(false);
  const [specialUser, setSpecialUser] = useState("");
  const [urlAction, setUrlAction] = useState(false);
  const [urlAction2, setUrlAction2] = useState(false);
  const [quickReply, setQuickReply] = useState(false);
  const [buttonType, setButtonType] = useState("Select button type");
  const [isChecked, setisChecked] = useState(true);
  const [quickRepCount, setQuickRepCount] = useState(1);
  const [selectedOption, setSelectedOption] = useState([""]);

  // console.log("callToAction:", callToAction);
  // console.log("urlAction:", urlAction);
  // console.log("urlAction2:", urlAction2);
  // console.log("quickReply:", quickReply);
  // console.log("buttonType:", buttonType);
  // props.sendButtonData([callToAction]);
  //   props.sendURLButton([urlAction]);
  //   props.sendURLButton2([urlAction2]);
  //   props.sendQuickButton([quickReply]);
  //   props.onButtonTypeChange(buttonType);


  // console.log(finalRetrieveData)

  useEffect(() => {
    if (paramid !== undefined) {
      setisChecked(true);
      setdefaultButtnData(props.defaultButtnData);
      if (props.defaultButtnData.length > 0) {
        if (props.defaultButtnData[0].actionType === "calltoaction") {
          setButtonType("call to action");
          props.defaultButtnData.map((item) => {
            let key = Object.keys(item);
            if (key.includes("urltext")) {
              setUrlAction(item);
            }
            if (key.includes("urltext2")) {
              setUrlAction2(item);
            } else if (key.includes("phone")) {
              setCallToAction(item);
            }
          });
        }
        if (props.defaultButtnData[0].actionType === "quickReply") {
          setButtonType("quick reply");

          const convertObjectToArray = (obj) => {
            return Object.keys(obj).map(key => ({ [key]: obj[key] }));
          };

          const transformedArray = convertObjectToArray(props.defaultButtnData[0]);
          const removeActionType = (arr) => {
            return arr.filter(item => !Object.keys(item).includes("actionType"));
          };

          const filteredArray = removeActionType(transformedArray);
          setQuickReply(props.defaultButtnData[0]);
          setQuickRepCount(filteredArray.length);
        }
      }
    }
  }, [props.defaultButtnData, paramid]);

  useEffect(() => {
    if (Array.isArray(finalRetrieveData)) {
      const buttonData = finalRetrieveData.flatMap((x) => {
        if (Array.isArray(x.components)) {
          return x.components.flatMap((item) => item.buttons || []);
        }
        return [];
      });

      if (buttonData[0].type === "QUICK_REPLY") {
        setButtonType("quick reply")
      }
      else {
        setButtonType("call to action")
      }

      const allComponents = finalRetrieveData.flatMap((x) =>
        Array.isArray(x.components) ? x.components : []
      );

      const buttonInnerData = allComponents
        .filter(component => component.type === 'BUTTONS')
        .map(component => ({ buttons: component.buttons }));

      let dataLength = buttonInnerData.map(x => x.buttons.length)


      setQuickRepCount(dataLength[0])
      // Assume buttonInnerData is available and props.cards is the card key
      buttonInnerData.forEach((buttonSet, cardIndex) => {
        buttonSet.buttons.forEach((button, buttonIndex) => {
          setQuickReply(prevState => ({
            ...prevState,
            [cardIndex + 1]: {
              ...prevState[cardIndex + 1],
              ['button' + (buttonIndex + 1)]: button.text,
              actionType: "quickReply",
            }
          }));
        });
      });

      const newOptions = [];

      buttonInnerData.forEach((items, cardIndex) => {
        const targetButton = items.buttons[cardIndex];

        if (!targetButton) return;

        if (targetButton.type?.includes("phone_number")) {
          newOptions.push({ value: "callphone", label: "Call Phone number" });
        }

        if (targetButton.type?.includes("url")) {
          newOptions.push({ value: "visitwebsite1", label: "Visit website 1" });
        }
      });

      // Filter out any empty/falsy entries just in case
      const filteredOptions = newOptions.filter(Boolean);
      setSelectedOption(filteredOptions);

      const callToActionData = {};
      const urlActionData = {};
      const urlAction2Data = {};

      buttonInnerData.forEach((card, index) => {
        // Extract phone_number data
        const phoneBtn = card.buttons.find(btn => btn.type === 'phone_number');
        if (phoneBtn && phoneBtn.phone_number) {
          const fullNumber = phoneBtn.phone_number;
          const countryCode = fullNumber.slice(0, 2); // assuming first 2 digits are country code
          const phoneNumber = fullNumber.slice(2);    // rest is the phone number

          callToActionData[index + 1] = {
            text: phoneBtn.text,
            phone: phoneNumber,
            countryCode: countryCode,
            actionType: "calltoaction",
          };
        }

        // Extract URL data
        const urlBtn = card.buttons.find(btn => btn.type === 'url');
        if (urlBtn && urlBtn.url) {
          urlActionData[index + 1] = {
            urltext: urlBtn.text,
            url: urlBtn.url,
            actionType: "calltoaction",
          };
        }

        const urlBtn2 = card.buttons.find(btn => btn.type === 'url');
        if (urlBtn2 && urlBtn2.url) {
          urlAction2Data[index + 1] = {
            urltext: urlBtn2.text,
            url: urlBtn2.url,
            actionType: "calltoaction",
          };
        }
      });


      // Now update state once
      setCallToAction((prevState) => ({
        ...prevState,
        ...callToActionData,
      }));

      setUrlAction((prevState) => ({
        ...prevState,
        ...urlActionData,
      }));

      setUrlAction2((prevState) => ({
        ...prevState,
        ...urlAction2Data,
      }));

    }
  }, [finalRetrieveData]);

  useEffect(() => {
    props.defaultButtnData.forEach((item) => {
      const keyys = Object.keys(item);
      if (keyys.includes("phone")) {
        const newObj = { value: "callphone", label: "Call Phone number" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("urltext")) {
        const newObj = { value: "visitwebsite1", label: "Visit website 1" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
      if (keyys.includes("urltext2")) {
        const newObj = { value: "visitwebsite2", label: "Visit website 2" };
        setSelectedOption((prevDefaultopt) => [...prevDefaultopt, newObj]);
      }
    });
  }, [props.defaultButtnData]);

  useEffect(() => {
    getUser();
  });

  const getUser = async () => {
    let paramData = {
      user_id: userId,
      method: "retrieve",
      token: userToken
    }
    let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
    if (data.data.success === true) {
      setSpecialUser(data.data.data);
    }
  }

  const buttonHandler = (selectedButtonOptions) => {
    const selectedValues = selectedButtonOptions.map(option => option.value);
    setButtonType({
      callToAction: selectedValues.includes("call to action"),
      quickReply: selectedValues.includes("quick reply"),
    });
    props.sendButtonData(false);
    props.sendURLButton(false);
    setCallToAction(false);
    setUrlAction(false);
    setUrlAction2(false);
    setQuickReply(false);
    setButtonValue();
  };

  const buttonHnadlar = (event) => {
    event.target.checked ? setisChecked(true) : setisChecked(false);
  };

  const setButtonValue = () => {
    props.sendButtonData([callToAction]);
    props.sendURLButton([urlAction]);
    props.sendURLButton2([urlAction2]);
    props.sendQuickButton([quickReply]);
    props.onButtonTypeChange(buttonType);
  };

  useEffect(() => {
    setButtonValue();
  }, [callToAction, urlAction, urlAction2, quickReply, buttonType]);

  const changeHandler = (e) => {
    if (!e?.target?.name) return;

    const { name, value } = e.target;

    setCallToAction((prevState) => ({
      ...prevState,
      [props.cards]: {
        ...prevState[props.cards],
        [name]: value,
        actionType: "calltoaction",
      }
    }));
  };


  const urlHandler = (e) => {
    if (!e?.target?.name) return;

    const { name, value } = e.target;

    setUrlAction((prevState) => ({
      ...prevState,
      [props.cards]: {
        ...prevState[props.cards],
        [name]: value,
        actionType: "calltoaction",
      }
    }));
  };


  // console.log

  const urlHandler2 = (e) => {
    setUrlAction2((prevState) => ({
      ...prevState,
      [props.cards]: {
        ...prevState[props.cards],
        [e.target.name]: e.target.value,
        actionType: "calltoaction",
      }
    }))
  };

  const quickLinkhandler = (e) => {
    setQuickReply((prevState) => ({
      ...prevState,
      [props.cards]: {
        ...prevState[props.cards], // preserve previous values for this card
        [e?.target?.name]: e?.target?.value,
        actionType: "quickReply",
      }
    }));
  };

  const addQuickRepInput = (e) => {
    if (quickRepCount < 3) {
      setQuickRepCount(quickRepCount + 1);
    }
  };

  const handleSelect = (selectedValue) => {
    setSelectedOption(selectedValue);
    if (selectedValue.length === 0) {
      setCallToAction(false);
      setUrlAction(false);
      setUrlAction2(false);
      return;
    }

    let stringArray = JSON.stringify(selectedValue);

    let phoneTextIndex = stringArray.indexOf("callphone");
    let urlTextIndex = stringArray.indexOf("visitwebsite1");
    let urlTextIndex2 = stringArray.indexOf("visitwebsite2");

    if (phoneTextIndex === -1) {
      setCallToAction(false);
    }

    if (urlTextIndex === -1) {
      setUrlAction(false);
    }
    if (urlTextIndex2 === -1) {
      setUrlAction2(false);
    }
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      cursor: "pointer",
    }),
  };

  const options = [
    { value: "call to action", label: "Call To Action" },
    { value: "quick reply", label: "Quick Reply" },
  ];

  return (
    <>
      <div className="whatsapp-options">
        <label>
          <h4>
            Button<span className="text-muted">(optional)</span>
          </h4>
          <p>
            Create buttons that let customers respond to your message or take
            action.
          </p>
        </label>
        {/* {props.cards > 1 ? null : */}
        <label className="switch">
          <input
            type="checkbox"
            defaultChecked={isChecked === true ? "checked" : null}
            onChange={buttonHnadlar}
          />
          <span className="slider round"></span>
        </label>
      </div>
      {isChecked && (
        <>
          {/* {props.cards > 1 ? null : */}

          {/* <select
              disabled={paramid || props.cards > 1 ? true : false}
              onChange={buttonHandler}
              value={buttonType}
              className="form-control cursor-pointer"
            >
              <option value={"Select button type"}>Select button type</option>
              <option value={"call to action"}>Call To Action</option>
              <option value={"quick reply"}>Quick Reply</option>
            </select> */}
          <div className="input-group drop-down-icons">
            <Select
              options={options}
              isDisabled={paramid || props.cards > 1 ? true : false}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isMulti
              components={{ Option }}
              styles={{
                ...buttonType,
                menuPortal: base => ({ ...base, zIndex: 9999 })
              }}
              classNamePrefix="select"
              placeholder="Select button type"
              onChange={buttonHandler}
              menuPortalTarget={document.body}
            />
          </div>


          {buttonType.callToAction && (

            <div className="call-action-area">
              {/* {props.cards > 1 ? null : */}
              <Select
                options={
                  [
                    { value: "callphone", label: "Call Phone number" },
                    { value: "visitwebsite1", label: "Visit website 1" },
                    { value: "visitwebsite2", label: "Visit website 2" },
                  ]
                }
                closeMenuOnSelect={false}
                value={selectedOption}
                hideSelectedOptions={false}
                isDisabled={paramid || props.cards > 1 ? true : false}
                // components={animatedComponents}
                isMulti
                components={{
                  Option,
                }}
                styles={customStyles}
                classNamePrefix="select"
                placeholder="Select type of action"
                onChange={handleSelect}
              />
              {selectedOption.map((option) => {
                if (option.value === "callphone") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="">
                          <span className="p-2"> Call phone number </span>
                        </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            id="inputFirstName"
                            name="text"
                            value={callToAction[props.cards]?.text || ""}
                            disabled={paramid ? true : false}
                            onChange={changeHandler}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="countryCode"
                            value={callToAction[props.cards]?.countryCode || ""}
                            disabled={paramid ? true : false}
                            id="inputFirstName"
                            onChange={changeHandler}
                            placeholder="country code"
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="phone"
                            value={callToAction[props.cards]?.phone || ""}
                            disabled={paramid ? true : false}
                            id="inputFirstName"
                            autoComplete="off"
                            onChange={changeHandler}
                            placeholder="Mobile Number"
                            maxLength={15}
                          />
                        </div>
                      </div>
                    </>
                  );
                }
              })}

              {selectedOption.map((option) => {
                if (option.value === "visitwebsite1") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="">
                          <span className="p-2"> Visit website 1 </span>
                        </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="urltext"
                            value={urlAction[props.cards]?.urltext || ""}
                            onChange={urlHandler}
                            id="inputFirstName"
                            disabled={paramid ? true : false}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4 drop-down-icons">
                          <select
                            value={urlAction[props.cards]?.urlType || ""}
                            onChange={urlHandler}
                            name="urlType"
                            className="form-control"
                            disabled={paramid ? true : false}
                          >
                            <option>URL Type</option>
                            <option>Static</option>
                            <option>Dynamic</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            onChange={urlHandler}
                            name="url"
                            value={urlAction[props.cards]?.url || ""}
                            disabled={paramid ? true : false}
                            className="form-control"
                            id="inputFirstName"
                            placeholder="www.example.com"
                          />
                        </div>
                      </div>
                      {urlAction[props.cards]?.urlType === "Dynamic" && <div className="input-group mt-1 mr-sm-1">
                        <div className="input-group-text">{`{{1}}`}</div>
                        <input
                          type="text"
                          value={urlHandler.sampleurl}
                          name="sampleurl"
                          required
                          onChange={urlHandler}
                          // disabled={props.cards > 1 ? true : false}
                          placeholder={`Sample Data of {{1}}`}
                          className="form-control"
                        />
                      </div>}
                    </>
                  );
                }
              })}

              {selectedOption.map((option) => {
                if (option.value === "visitwebsite2") {
                  return (
                    <>
                      <div className="choose-options">
                        <span className="p-2"> Visit website 2 </span>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            name="urltext2"
                            value={urlAction2[props.cards]?.urltext2 || ""}
                            onChange={urlHandler2}
                            placeholder="Button Text"
                            maxLength={20}
                          />
                        </div>
                        <div className="col-md-4 drop-down-icons">
                          <select
                            value={urlAction2[props.cards]?.urlType || ""}
                            onChange={urlHandler2}
                            name="urlType"
                            className="form-control"
                          >
                            <option>URL Type</option>
                            <option>Static</option>
                            <option>Dynamic</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <input
                            type="text"
                            onChange={urlHandler2}
                            name="url"
                            value={urlAction2[props.cards]?.url || ""}
                            // disabled={isButtonChecked && urlAction2?.urlType === "Dynamic"}
                            className="form-control"
                            placeholder="www.example.com"
                          />
                        </div>
                      </div>
                      {urlAction2[props.cards]?.urlType === "Dynamic" && (
                        <div className="input-group mt-1 mr-sm-1">
                          <div className="input-group-text">{"{{1}}"}</div>
                          <input
                            type="text"
                            name="sampleurl"
                            value={urlHandler2.sampleurl}
                            required
                            onChange={urlHandler2}
                            placeholder="Sample Data of {{1}}"
                            className="form-control"
                          />
                        </div>
                      )}
                    </>
                  );
                }
              })}
            </div>
          )}

          {buttonType.quickReply && (
            <div>
              <div className="call-action-area">
                {Array.from({ length: quickRepCount }, (_, index) => (
                  <>
                    <div
                      className="input-group mb-1 "
                      id={`button${index + 1}`}
                      key={index}
                    >
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          {" "}
                          Button {index + 1}
                        </span>
                      </div>
                      <input
                        type="text"
                        onChange={quickLinkhandler}
                        name={`button${index + 1}`}
                        value={quickReply?.[props.cards]?.[`button${index + 1}`] || ""}
                        maxLength={20}
                        className="form-control"
                        placeholder="Username"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        disabled={paramid ? true : false}
                      />

                    </div>
                    {/* <div className="float-right mt-2" >Character:0/20
</div> */}
                    {/* <button onClick={delInput(index)}>delete</button> */}
                  </>
                ))}
                {/* {props.cards > 1 ? null : */}
                <button
                  className="btn btn-sm btn-primary mb-2 mt-4 float-right"
                  onClick={addQuickRepInput}
                  disabled={paramid || props.cards > 1 ? true : false}
                >
                  Add Button
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default CarouselButton;